import React from "react";
import OrderItemsTable from "./OrderItemsTable";
import { OrderItemResponse } from "@/api";

interface OrderItemsViewProps {
  items: OrderItemResponse[];
}

export default function OrderItemsView({
  items = [],
}: OrderItemsViewProps) {
  return (
    <OrderItemsTable
      items={items}
      showFinancials
    />
  );
}